interface IconProps {
  size?: number
  className?: string
}

export function PousseIcon({ size = 24, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className={className}>
      <path d="M20 32V20M20 20c-4-2-8 0-8 4M20 20c4-2 8 0 8 4" />
    </svg>
  )
}

export function TigeIcon({ size = 24, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className={className}>
      <path d="M20 34V14M20 18c-5-3-10 0-10 5M20 18c5-3 10 0 10 5M20 24c-3-2-6-1-7 2M20 24c3-2 6-1 7 2" />
    </svg>
  )
}

export function ArbreIcon({ size = 24, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className={className}>
      <path d="M20 36V10M14 18h12M11 24h18M9 30h22" />
    </svg>
  )
}

export function ForetIcon({ size = 24, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className={className}>
      <path d="M8 32V14M14 32V10M20 32V8M26 32V10M32 32V14M4 32h32" />
    </svg>
  )
}

export function StreakIcon({ streak, size = 24, className }: { streak: number; size?: number; className?: string }) {
  if (streak >= 90) return <ForetIcon size={size} className={className} />
  if (streak >= 31) return <ArbreIcon size={size} className={className} />
  if (streak >= 11) return <TigeIcon size={size} className={className} />
  return <PousseIcon size={size} className={className} />
}
